<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: '11',
          }"
        ></appl-menu-icon>
        {{ $t('출장신청 구분을 선택해주세요') }}
      </v-col>
    </v-row>

    <!-- 출장신청서 종류 -->
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in menuList"
          :key="i"
          class="gntType-item"
        >
          <v-list-item-content @click="selectMenu(item)">
            <v-list-item-title> {{ $t(item.codeNm) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import routerNames from '@/const/routerConstants';
import { getBizTripType } from '@/api/application';
import { mapGetters, mapMutations } from 'vuex';

/** 출장 신청서 구분 선택 */
export default {
  data: () => ({
    menuList: [],
  }),

  computed: {
    ...mapGetters('ELA', ['GET_GNT_GUBUN_CD', 'GET_SEARCH_APPL_CD']),
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
    ...mapMutations('ELA', ['SET_BIZ_TRIP_GNT_NM', 'SET_GNT_CD']),

    /* 신청서 선택 */
    async selectMenu(menu) {
      // this.SET_APP_MENU({
      //   gubun: 'bizTrip',
      //   applCd: this.GET_SEARCH_APPL_CD,
      //   gntGubunCd: menu.gntGubunCd,
      //   menuNm: menu.codeNm,
      // }); // 신청서 메뉴 정보 저장 (삭제예정!!! 필요가 없음...gntGubunCd는 어차피 처음에 저장햇고 그거랑 같음..)
      this.SET_BIZ_TRIP_GNT_NM(menu.codeNm); // 출장신청 근태명 저장 (옵션화면에서 표기하기 위함!)
      this.SET_GNT_CD(menu.code); // gntCd 저장

      // 다음화면으로 이동
      this.$router.push(routerNames.StartDate);
    },

    /* 출장구분 조회 */
    async fetchBizTripTypeMenu() {
      try {
        const response = await getBizTripType({
          cmd: 'gntCd',
          searchGntGubunCd: this.GET_GNT_GUBUN_CD,
        });

        this.menuList = response.data.data;
        this.OFF_APP_SPINNER();
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.ON_APP_SPINNER(); // 스피너 ON

    // 초기 데이터 조회
    this.fetchBizTripTypeMenu();
  },
  components: {
    ApplMenuIcon,
  },
};
</script>

<style>
.row.title-wrap {
  margin-bottom: 10px;
}
.chip-wrap {
  padding: 0px 22px 20px;
}
.gntType-item {
  padding-left: 54px;
  padding-right: 54px;
}
.divider::before {
  margin: 0 10px;
}
</style>
